import { gql } from '@apollo/client';

export const CREATE_ROLE = gql`
  mutation CreateRole($input:CreateRoleInput) {
    createRole(role_input:$input) {
        data {
            role {
                description
                id
                name
            }
        }
        error {
            code
            field
            message
        }
    }
}
`;
export const UPDATE_ROLE = gql`
  mutation UpdateRole($input:UpdateRoleInput!) {
    updateRole(input:$input) {
        data {
            role {
                description
                id
                name
            }
        }
        error {
            code
            field
            message
        }
    }
}
`;
export const Delete_ROLE = gql`
  mutation DeleteRole($id:UUID!) {
    deleteRole(id: $id) {
        data {
            message
        }
        error {
            code
            field
            message
        }
    }
}
`;
